import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Tabs from "@mui/material/Tabs";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { BaseLink, HXTextField, withExplicitProps } from "../base.styles";
import { FlexColumn } from "../common.styles";
import { ErrorMessageText } from "../HXDesktopPage.styles";
import { Input } from "./GlobalAdminOrganizationFormBase.styles";
import { FormLabel, UnlimitedHeightFormItem } from "./GlobalAdminUserFormBase.styles";
export const GlobalAdminProjectsViewParent = styled.div ``;
export const ProjectEditor = styled.div `
    margin-left: 16px;
`;
export const ProjectEditorHeader = styled.div `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    margin-bottom: 12px;
`;
export const BackToProjectsLink = styled(BaseLink) `
    display: inline-flex;
    align-items: center;
    gap: 2px;
    margin-left: -4px;
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    text-decoration: none;

    &:hover {
        color: ${colors.navy_main};
        text-decoration: underline;
    }
`;
export const BackChevron = styled(ChevronLeftIcon) `
    && {
        font-size: 18px;
    }
`;
export const ProjectEditorTitle = styled.div `
    font-size: ${fontSizes.LARGE};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const EditorError = styled(ErrorMessageText) `
    display: block;
    margin: 0 0 12px;
`;
export const EditorSuccess = styled.div `
    background-color: #e8f5e9;
    color: #2e7d32;
    padding: 12px 16px;
    border-radius: 6px;
    display: block;
    margin: 0 0 12px;
`;
export const ProjectPageTabs = styled(Tabs) `
    display: inline-flex;
    min-height: 0;
    margin-bottom: 12px;
    padding: 4px;
    background-color: ${colors.black_4};
    border: 1px solid ${colors.black_12};
    border-radius: 8px;

    & .MuiTabs-indicator {
        display: none;
    }

    & .MuiTabs-flexContainer {
        gap: 4px;
    }

    & .MuiTab-root {
        min-height: 0;
        min-width: 0;
        padding: 6px 14px;
        border-radius: 6px;
        font-size: ${fontSizes.SMALL};
        font-weight: ${fontWeights.SEMI_BOLD};
        text-transform: none;
        color: ${colors.black_lighter};
    }

    & .MuiTab-root.Mui-selected {
        color: ${colors.black_main};
        background-color: white;
        box-shadow: 0 1px 2px ${colors.black_10};
    }
`;
export const TableCard = styled.div `
    margin-top: 12px;
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
    overflow: hidden;
`;
export const ProjectTable = styled.table `
    font-size: ${fontSizes.SMALL};
    width: 100%;
    border-collapse: collapse;

    & thead th {
        text-align: left;
        font-size: ${fontSizes.MICRO};
        font-weight: 600;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        color: ${colors.black_lighter};
        background-color: ${colors.black_4};
        border-bottom: 1px solid ${colors.black_30};
    }

    & th,
    td {
        padding: 12px 16px;
        vertical-align: middle;
    }

    & tbody tr + tr td {
        border-top: 1px solid ${colors.black_12};
    }

    & tbody tr:hover {
        background-color: ${colors.black_4};
    }
`;
export const ActionTableCell = styled.td `
    width: 160px;
    text-align: right;
`;
export const EmptyStateCell = styled.td `
    && {
        padding: 40px 16px;
    }
    text-align: center;
    color: ${colors.black_lighter};
`;
export const StatusBadge = withExplicitProps(styled.span, "published") `
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: ${fontSizes.MICRO};
    font-weight: 600;
    color: ${(props) => (props.published ? colors.chips_forest : colors.chips_slate)};
    background-color: ${(props) => (props.published ? colors.chips_forest_10 : colors.chips_slate_10)};
`;
export const FormCard = styled.div `
    background-color: white;
    border: 1px solid ${colors.black_30};
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 16px;
`;
export const FormCardTitle = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: 600;
    margin-bottom: 4px;
`;
export const FormSectionTitle = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 4px;
`;
export const PageDescription = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    max-width: 720px;
    margin-bottom: 16px;
`;
export const FormHint = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    max-width: 560px;
    margin-bottom: 8px;
`;
export const FieldHint = styled(FormHint) `
    margin-top: 4px;
    margin-bottom: 0;
`;
export const CharacterCount = withExplicitProps(styled(FieldHint), "overLimit") `
    color: ${(props) => (props.overLimit ? colors.tulip_main : colors.black_lighter)};
`;
export const FieldRow = styled(UnlimitedHeightFormItem) `
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: 12px 0;

    & > ${FormLabel} {
        width: auto;
        max-width: 560px;
        line-height: 20px;
    }
`;
export const InlineRequiredMark = styled(FormLabel) `
    display: inline;
    width: auto;
    font-weight: inherit;
`;
export const WideInput = styled(Input) `
    flex: 1;
    min-width: 0;

    & ${HXTextField} {
        width: 100%;
        max-width: 560px;
    }
`;
export const CheckboxStack = styled.div `
    display: flex;
    flex-direction: column;
    gap: 4px;
`;
export const IntervalRow = styled.div `
    display: flex;
    align-items: center;
    gap: 12px;

    && ${HXTextField} {
        width: 90px;
    }
`;
export const PhoneExtensionRow = styled.div `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 16px;
    width: 100%;
    max-width: 560px;
`;
export const PhoneNumberField = styled.div `
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;

    & ${HXTextField} {
        width: 100%;
    }
`;
export const PhoneExtensionField = styled.div `
    width: 140px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;

    & ${HXTextField} {
        width: 100%;
    }
`;
export const QuestionCard = styled.div `
    margin-top: 12px;
    padding: 12px 16px;
    background-color: ${colors.black_4};
    border: 1px solid ${colors.black_12};
    border-radius: 6px;
`;
export const QuestionCardHeader = styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > *:first-child {
        margin-top: 0;
    }
`;
export const AddQuestionRow = styled.div `
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 16px;
`;
export const LogoUploadRow = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
    flex-wrap: wrap;
`;
export const FormActions = styled.div `
    position: sticky;
    bottom: 0;
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 16px 0;
    background-color: ${colors.white_background};
    border-top: 1px solid ${colors.black_12};
`;
export const FormActionsSpacer = styled.div `
    flex: 1;
`;
export const PublishConfirmDialogContent = styled(FlexColumn) `
    gap: 24px;
    padding: 8px 24px 24px 24px;
`;
export const PublishConfirmDialogRequiredFieldLabel = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const PublishConfirmDialogButtons = styled.div `
    display: flex;
    justify-content: flex-end;
`;
